import React, { useContext } from 'react'
import IntercomView from 'react-intercom'
import { AppContext } from '../../index'

function Intercom() {
  const { state } = useContext(AppContext)
  const appId = process.env.REACT_APP_INTERCOM_APP_ID
  const { user } = state.auth

  if (!appId) {
    return null
  } else {
    if (!user) {
      return (
        <IntercomView appID={appId} />
      )
    } else {
      const userEmail = user.email
      const userFullName = `${user.firstName} ${user.lastName}`
      const intercomUserHash = user.intercomUserHash

      const userData = {
        user_id: user.id,
        email: userEmail,
        name: userFullName,
        user_hash: intercomUserHash
      }

      return (
        <IntercomView appID={appId}  {...userData} />
      )
    }
  }
}

export default Intercom
